// Copyright (c) 2021 WiseTime. All rights reserved.

import {
  ListTimeRowsByDateRequest,
  ListTimeRowsByDateResponse,
} from "../../../generated/wisetime/user/timeline/v4/timeline_pb"
import { Observable, of } from "rxjs"
import { Action } from "redux"
import { grpc } from "../../../app/rpc/executor"
import { timelineClient } from "../../../app/rpc/client"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as TimelineActions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type ListTimeRowsByDateRpc = (request: ListTimeRowsByDateRequest) => Observable<ListTimeRowsByDateResponse>

export const listTimeRowsByDate = (listTimeRowsByDateRpc: ListTimeRowsByDateRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TimelineActions.listTimeRowsByDate.match),
      mergeMap(action => of(action.payload).pipe(
        mergeMap(listTimeRowsByDateRpc),
        map(t => t.toObject().timeRowsList),
        map(timeRowsList => TimelineSlice.setTimeRowsForDates({
          timeRows: timeRowsList,
          window: {
            startDateLocal: action.payload.getStartActivityDate(),
            endDateLocal: action.payload.getEndActivityDate(),
          },
          ofTrashStatus: action.payload.getTrashStatus()
        })),
        catchError(_ => of(showSnackBar({
          message: t({ id: "msg_list_time_rows_failed", message: "Failed to get fetch time rows. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com." }),
          messageType: "ERROR",
        })))),
      )
    )

const listTimeRowsByDateRpc = (request: ListTimeRowsByDateRequest): Observable<ListTimeRowsByDateResponse> => {
  return grpc(() => timelineClient.listTimeRowsByDate(request, null))
}

export default listTimeRowsByDate(listTimeRowsByDateRpc)
